import * as React from 'react';
import { useCallback } from 'react';
import { Form } from '../Form/Form';
import PassengersConsents from '../PassengersConsents/PassengersConsents';
import PassengersToolbar from '../Form/PassengersToolbar/PassengersToolbar';
const FormBlockSlot = props => {
    const renderToolbar = useCallback(({ values }, formRef) => {
        var _a, _b, _c, _d;
        return (React.createElement(React.Fragment, null,
            React.createElement(PassengersConsents, { customer: props.customer, login: (_a = values.customer) === null || _a === void 0 ? void 0 : _a.email, isAuthorized: !!((_b = props.userInfo) === null || _b === void 0 ? void 0 : _b.userProfile) }),
            React.createElement(PassengersToolbar, { formRef: formRef, disableBooking: (_c = props.orderSubsidyState) === null || _c === void 0 ? void 0 : _c.isSubsidiesRejected, loading: (_d = props.orderSubsidyState) === null || _d === void 0 ? void 0 : _d.isLoading, currentStep: props.currentStep, setNextStep: props.setNextStep, showConsents: false })));
    }, [props.userInfo, props.customer, props.orderSubsidyState, props.currentStep, props.setNextStep]);
    return React.createElement(Form, Object.assign({}, props, { renderToolbar: renderToolbar }));
};
export default FormBlockSlot;
